/** Socket.IO event names emitted by the backend. */
export const SOCKET_EVENTS = {
  /** Unified channel message create — admin/member/Aria. Envelope uses `data`. */
  MESSAGE_NEW: 'message:new',
  PARTNER_GROUP_CHAT_MESSAGE: 'partner:group_chat:message',
  PARTNER_GROUP_CHAT_REACTION: 'partner:group_chat:reaction',
  PARTNER_TEMPORARY_DISABLE_UPDATED: 'partner:temporary_disable:updated',
};
